import React from 'react';
import PropTypes from 'prop-types';

const EducationIcons = ({ icon, size = 24 }) => {
  if (icon === 'method') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path fill="currentColor" d="m17.47.4 4.38 22.5L.7 16.05 17.47.4Z" />
      </svg>
    );
  }
  if (icon === 'collection') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m9.12 1 8.93 6.09-9.74 4.7L9.11 1ZM4.74 21.75a4.74 4.74 0 1 0 0-9.49 4.74 4.74 0 0 0 0 9.49ZM23.5 14.18l-8.11-2.42-2.41 8.12 8.1 2.4 2.42-8.1Z"
        />
      </svg>
    );
  }
  if (icon === 'action') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path fill="currentColor" d="m18.3.12 5.36 13.38-11 9.93L.5 16.18 4 1.78 18.3.12Z" />
      </svg>
    );
  }
  if (icon === 'workshop') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path fill="currentColor" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" />
      </svg>
    );
  }
  if (icon === 'presentation') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m17.06.95 6.06 9.8-5.46 10.43-11.52.6L.1 11.97 5.55 1.55l11.51-.6Z"
        />
      </svg>
    );
  }
  if (icon === 'training') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          d="M23.1286 7.04778L6.05698 0.70295L-0.0120035 17.0323L17.0596 23.3772L23.1286 7.04778Z"
          fill="currentColor"
        />
      </svg>
    );
  }
  if (icon === 'tutorial') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m16.02.2 1.84 3.88 4.04.86-.68 4.24L24 12.36l-2.96 3 .46 4.28-4.08.6L15.4 24l-3.66-2L8 23.8l-1.84-3.88-4.04-.86.68-4.24L0 11.64l2.96-3-.46-4.28 4.08-.6L8.6 0l3.66 2L16 .2h.02Z"
        />
      </svg>
    );
  }
  return null;
};

EducationIcons.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number
};

export default EducationIcons;
